import React from 'react';

const typeColors = {
  Normal: { bg: 'bg-gray-400', text: 'text-gray-900', border: 'border-gray-500' },
  Fire: { bg: 'bg-red-500', text: 'text-white', border: 'border-red-600' },
  Water: { bg: 'bg-blue-500', text: 'text-white', border: 'border-blue-600' },
  Electric: { bg: 'bg-yellow-400', text: 'text-gray-900', border: 'border-yellow-500' },
  Grass: { bg: 'bg-green-500', text: 'text-white', border: 'border-green-600' },
  Ice: { bg: 'bg-cyan-300', text: 'text-gray-900', border: 'border-cyan-400' },
  Fighting: { bg: 'bg-red-700', text: 'text-white', border: 'border-red-800' },
  Poison: { bg: 'bg-purple-500', text: 'text-white', border: 'border-purple-600' },
  Ground: { bg: 'bg-yellow-600', text: 'text-white', border: 'border-yellow-700' },
  Flying: { bg: 'bg-indigo-400', text: 'text-white', border: 'border-indigo-500' },
  Psychic: { bg: 'bg-pink-500', text: 'text-white', border: 'border-pink-600' },
  Bug: { bg: 'bg-lime-500', text: 'text-white', border: 'border-lime-600' },
  Rock: { bg: 'bg-yellow-800', text: 'text-white', border: 'border-yellow-900' },
  Ghost: { bg: 'bg-purple-700', text: 'text-white', border: 'border-purple-800' },
  Steel: { bg: 'bg-gray-500', text: 'text-white', border: 'border-gray-600' },
  Dark: { bg: 'bg-gray-800', text: 'text-white', border: 'border-gray-900' },
  Dragon: { bg: 'bg-indigo-700', text: 'text-white', border: 'border-indigo-800' },
  Fairy: { bg: 'bg-pink-300', text: 'text-gray-900', border: 'border-pink-400' }
};

const variantStyles = {
  default: 'shadow-md',
  strong: 'shadow-md',
  weak: 'shadow-md',
  resistant: 'shadow-md',
  immune: 'shadow-md'
};

function TypeBadge({ type, variant = 'default' }) {
  const colors = typeColors[type] || typeColors.Normal;
  const variantStyle = variantStyles[variant];

  return (
    <span
      className={`
        inline-block px-3 py-1 rounded-full text-sm font-semibold
        ${colors.bg} ${colors.text} ${colors.border} border
        ${variantStyle}
        transition-all duration-200 hover:scale-105
      `}
    >
      {type}
    </span>
  );
}

export default TypeBadge;
